import { connect } from 'react-redux'
import requestPositionElement from '../sagas/requestPositionElement'
import requestAddDocumentToCard from '../sagas/requestAddDocumentToCard'
import requestUploadStart from '../sagas/requestUploadStart'
import { sagaActions as rootSagaActions } from 'store/sagas'
import viewSelector from './viewSelector'
import View from './View'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  viewSelector,
  {
    fetchHeartbeats: rootSagaActions.fetchHeartbeats,
    requestPositionElement,
    requestHeartbeat: rootSagaActions.requestHeartbeat,
    requestUploadStart,
    requestMarkTaggedNotificationsAsRead: rootSagaActions.requestMarkTaggedNotificationsAsRead,
    requestAddDocumentToCard,
  }
)(View))
